import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { CaretDown, List, VideoCamera, DeviceMobile } from "@phosphor-icons/react";
import { PRODUCTS, NAV_EXTRA, SIGNIN_URL, PILOT_URL, slug } from "@/lib/brand";

const NAV = [...PRODUCTS, ...NAV_EXTRA];

const linkCls = (current) =>
  current
    ? "px-2 py-1 bg-ink-900 text-white"
    : "px-2 py-1 text-ink-700 hover:text-ink-900 transition-colors";

export function MarketingLinks() {
  return (
    <nav className="hidden xl:flex items-center gap-1 text-[13px] font-medium" data-testid="global-nav">
      {NAV.map((n) => (
        <a key={n.name} href={n.url} data-testid={`nav-${slug(n.name)}`} aria-current={n.current ? "page" : undefined} className={linkCls(n.current)}>
          {n.name}
        </a>
      ))}
    </nav>
  );
}

export function SignInMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="nav-signin" className="rounded-none text-ink-900 hover:bg-ink-100 hover:text-ink-900 focus-visible:bg-ink-100 data-[state=open]:bg-ink-100 data-[state=open]:text-ink-900">
          Sign in <CaretDown size={12} weight="bold" className="ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none w-56" data-testid="nav-signin-menu">
        <DropdownMenuLabel className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-500">Choose access</DropdownMenuLabel>
        <DropdownMenuItem asChild className="rounded-none cursor-pointer">
          <a href={SIGNIN_URL} data-testid="nav-signin-cctv"><VideoCamera size={16} weight="bold" className="mr-2" /> CCTV access</a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="rounded-none cursor-pointer">
          <a href={SIGNIN_URL} data-testid="nav-signin-mobile"><DeviceMobile size={16} weight="bold" className="mr-2" /> Mobile access</a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function PilotCta() {
  return (
    <a href={PILOT_URL} className="hidden sm:inline-flex">
      <Button size="sm" data-testid="nav-cta" className="rounded-none bg-safety hover:bg-safety-hover text-white">
        Book a pilot
      </Button>
    </a>
  );
}

export function MobileNav() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="sm" className="xl:hidden rounded-none px-2" aria-label="Menu" data-testid="nav-mobile-toggle">
          <List size={20} weight="bold" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="rounded-none w-72" data-testid="nav-mobile-sheet">
        <SheetTitle className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-500">Menu</SheetTitle>
        <nav className="mt-6 flex flex-col gap-1 text-sm">
          {NAV.map((n) => (
            <a key={n.name} href={n.url} data-testid={`mobile-nav-${slug(n.name)}`} className={`${linkCls(n.current)} py-2`}>
              {n.name}
            </a>
          ))}
          <a href={PILOT_URL} data-testid="mobile-nav-cta" className="mt-4 px-2 py-3 bg-safety text-white text-center font-semibold">
            Book a pilot
          </a>
        </nav>
      </SheetContent>
    </Sheet>
  );
}
